import { applyMiddleware, compose, createStore } from 'redux';

import createReducer from './reducers/index';
import trackingMiddleware from './tracking-middleware';

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

export default function createCalculatorStore({ initialState }) {
  return createStore(
    createReducer({ initialState }),
    composeEnhancers(applyMiddleware(trackingMiddleware))
  );
}
